/**
 * Conditional className joiner — replaces ternary chains.
 * Usage: cn('base', condition && 'active', 'always')
 */
export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}

/**
 * Format price in Dutch locale (EUR).
 * Single source of truth — replaces duplicates in ProductCard, ProductModal, CartPage.
 */
export function formatPrice(price: number): string {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  }).format(price);
}
